import React from "react";
import Chip from "@mui/material/Chip";

const QueryPills = ({ appliedQuery, handleClick, handleDelete }) => {
  return appliedQuery.map(queryPart => (
    <Chip
      key={"query-part-" + queryPart}
      label={
        <div>
          <span style={{ fontWeight: "bold" }}>SEARCH: </span>"{queryPart}"
        </div>
      }
      onClick={() => handleClick(queryPart)}
      onDelete={() => handleDelete(queryPart)}
      variant="outlined"
    />
  ));
};

export default QueryPills;
